import InAppMessage from "./in-app-message.js";
export default class HtmlMessage extends InAppMessage {
  constructor(i, o, d, e, r, t, s, v, n, u, a, c) {
    super(
      i,
      void 0,
      void 0,
      o,
      d,
      void 0,
      void 0,
      void 0,
      (e = e || InAppMessage.DismissType.MANUAL),
      r,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      t,
      s,
      void 0,
      void 0,
      void 0,
      v,
      void 0,
      void 0,
      void 0,
      n,
      u,
      c,
      void 0,
      void 0,
    ),
      (this.messageFields = a),
      (this.messageFields = a);
  }
  od() {
    return !1;
  }
  $t(i) {
    if (this.ko === InAppMessage.Eo.Zo) {
      if (this.dd) return !1;
      this.dd = !0;
    }
    return this.ti.L(i), !0;
  }
  gt() {
    const i = super.gt(HtmlMessage.es);
    return (i[InAppMessage.ss.ed] = this.messageFields), i;
  }
  static Zn(i) {
    return new HtmlMessage(
      i[InAppMessage.ss.pa],
      i[InAppMessage.ss.xs],
      i[InAppMessage.ss.ua],
      i[InAppMessage.ss.da],
      i[InAppMessage.ss.la],
      i[InAppMessage.ss.ya],
      i[InAppMessage.ss.Sa],
      i[InAppMessage.ss.Aa],
      i[InAppMessage.ss.Ea],
      i[InAppMessage.ss.CSS],
      i[InAppMessage.ss.ed],
      i[InAppMessage.ss.Fa],
    );
  }
}
HtmlMessage.es = InAppMessage.Eo.Zo;
